module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f8U7M"))).then(() => module.bundle.root('iDabs'));